
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.125","height":"20.51"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-406.974 -284.184)"}},[_c('path',{attrs:{"data-name":"Path 8","d":"M419.315 285.716l9.544 16.531a.9.9 0 01-.778 1.348h-19.088a.9.9 0 01-.778-1.347l9.544-16.531a.917.917 0 011.556 0zm-.778 5.859v5.2","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.2"}}),_c('circle',{attrs:{"data-name":"Ellipse 1","cx":"1","cy":"1","r":"1","transform":"translate(417.596 299.284)","fill":"#fff"}})])])
          )
        }
      }
    